import { render, staticRenderFns } from "./MailTemplatesForm.vue?vue&type=template&id=7041bca4&scoped=true&"
import script from "./MailTemplatesForm.vue?vue&type=script&lang=js&"
export * from "./MailTemplatesForm.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplatesForm.vue?vue&type=style&index=0&id=7041bca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7041bca4",
  null
  
)

export default component.exports